import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import CustomAvatar from "../../../shared/UIParts/CustomAvatar";
import { Contact } from "../../../interfaces/DTO/crm/contact";
import { calculateAvatarStyle } from "../../../utils/avatarStyleCalculator";
import { formatName } from "../../../utils/namesFormater";

/** a client's card in the consulting drawer's tabs - the avatar and the name on top, the tab's content below */
const ContactTabCard: React.FC<{ contact: Contact; children: React.ReactNode }> = ({ contact, children }) => (
  <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3, width: "100%", display: "flex", flexDirection: "column" }}>
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5, mb: 2.5 }}>
      <CustomAvatar
        item={contact}
        isUser={true}
        userColor={calculateAvatarStyle(contact, true).backgroundColor}
        familyColor=""
        sx={{ width: 96, height: 96, fontSize: "2.25rem" }}
      />
      <Typography variant="h5" fontWeight={600} textAlign="center" sx={{ mt: 1 }}>
        {formatName(contact) || "ללא שם"}
      </Typography>
    </Box>
    {children}
  </Paper>
);

export default ContactTabCard;
